import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';

function GiftIdeas() {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGifts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/show-gifts`);
        setGifts(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchGifts();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="text-center p-8 text-red-500">Could not load gift ideas. Please try again later.</div>;
  }

  return (
    <div className='pt-8 space-y-2'>
      <h2 className='font-bold text-2xl text-black text-center'>Gift Ideas</h2>
      <div className="masonry-container">
        {gifts.map((gift) => (
          <div key={gift.id} className="masonry-item">
            <a href={gift.link} target="_blank" rel="noopener noreferrer" className="block">
              <div className="max-w-sm rounded overflow-hidden">
                <img 
                  src={`${process.env.REACT_APP_CDN_BASE_URL}/images/${gift.image}`}
                  alt={gift.title} 
                  className="w-full"
                  loading="lazy"
                />
                <div className="p-2 flex items-center justify-between">
                  <h2 className="text-sm line-clamp-2 text-ellipsis">{gift.title}</h2>
                  <h2 className="text-sm font-bold text-black">RM{gift.price}</h2>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GiftIdeas